export default __webpack_public_path__ + "static/media/video.c53a2ce7.svg";